export default {
  solutions: {
    breadcrumbHome: 'Accueil',
    breadcrumbCurrent: 'Solutions',
    hero: {
      eyebrow: 'Solutions',
      title: 'La bonne solution pour chaque bien',
      lead: 'Maison, surface commerciale ou entrepôt : nous trouvons ensemble le système de caméras optimal pour vos besoins.',
    },
    grid: {
      eyebrow: 'Solutions par type de bien',
      title: 'Six domaines, une promesse : une vraie sécurité',
      lead: 'Chaque carte mène à une vue dédiée avec les points de surveillance typiques et les solutions techniques adaptées.',
    },
    tag: { privat: 'Privé', gewerbe: 'Professionnel', innen: 'Intérieur', außen: 'Extérieur', neu: 'Nouveau', erweiterung: 'Extension' },
    more: 'En savoir plus',
    cta: {
      title: 'Vous ne savez pas quelle solution choisir ?',
      lead: 'Nous analysons ensemble votre bien et vous recommandons la bonne combinaison de caméras, enregistrement et accessoires.',
      primary: 'Conseil sans engagement',
      secondary: 'Lancer le planificateur de caméras',
    },
  },
};